// src/components/BottomNav.jsx
// Barra de navegación inferior — solo visible en mobile (max-width: 840px)

import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const TABS = [
  {
    path: '/dashboard',
    color: '#f5e642',
    labelKey: 'nav.analysis',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
      </svg>
    ),
  },
  {
    path: '/historial',
    color: '#48d9ff',
    labelKey: 'nav.history',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
  },
  {
    path: '/level',
    color: '#b87fff',
    labelKey: 'nav.myLevel',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="6" />
        <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
      </svg>
    ),
  },
  {
    path: '/progreso',
    color: '#9dff8a',
    labelKey: 'nav.progress',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
        <polyline points="16 7 22 7 22 13" />
      </svg>
    ),
  },
  {
    path: '/comparativas',
    color: '#ff9040',
    labelKey: 'nav.compare',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6"  y1="20" x2="6"  y2="14" />
      </svg>
    ),
  },
]

export default function BottomNav() {
  const { t } = useTranslation()
  return (
    <nav className="bottom-nav" aria-label={t('nav.analysis')}>
      {TABS.map((tab) => (
        <NavLink
          key={tab.path}
          to={tab.path}
          className={({ isActive }) =>
            isActive ? 'bottom-nav-item bottom-nav-item-active' : 'bottom-nav-item'
          }
          style={({ isActive }) => ({ '--tab-color': tab.color, opacity: isActive ? 1 : undefined })}
        >
          <span className="bottom-nav-icon">{tab.icon}</span>
          <span className="bottom-nav-label">{t(tab.labelKey)}</span>
        </NavLink>
      ))}
    </nav>
  )
}